import { connect } from 'react-redux';
import VehicleFeatures from 'vdp-used/components/VehicleFeatures/VehicleFeatures.jsx';

function mapStateToProps(state) {
    return {
        vehicle: state.vehicleV25,
    };
}

export default connect(mapStateToProps)(VehicleFeatures);
